<form *ngIf="block && form" [formGroup]="form">
  <pl-checkbox
    #plCheckbox
    [label]="block.data.label || ''"
    [formControlName]="FormControlName.items"
    [isFormSubmitted]="courseContentService.isMainFormSubmitted()"
    [isDisabled]="isDisabled"
    [minSelected]="+block.data.config.min_selected"
    [maxSelected]="+block.data.config.max_selected"
    [minItemsDisplayed]="5"
  />
</form>
